import axiosInstance from "./axiosInstance";
import { getDataCommon } from "./common";

const getDocsManual = () => getDataCommon("docsmanual.json");
const getDocsInfo = () => getDataCommon("docsinfo.json");
const getDocBookShelf = () => getDataCommon("docspdfshelf.json");
const getDocsBook = () => getDataCommon("docsbook.json");

export { getDocsManual, getDocsInfo, getDocsBook, getDocBookShelf };
